import { ActualsValueTypes } from 'partner360/models/actualValueTypes'
import { P360Currency } from 'partner360/models/P360Currency'

export const getFieldsWithCurrencyAndValueType = (field: string) => {
  const variants = [
    `${ActualsValueTypes.Ndp}${P360Currency.USD}`,
    `${ActualsValueTypes.Net}${P360Currency.USD}`,
    `${ActualsValueTypes.Ndp}${P360Currency.LocalCurrency}`,
    `${ActualsValueTypes.Net}${P360Currency.LocalCurrency}`,
  ]
  return variants.map((variant) => `${field}${variant}`)
}
